(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minos-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('minos-hero-slideshow')) {
    customElements.define('minos-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = Array.from(this.querySelectorAll('.minos-hero__slide'));
        this.selectors = Array.from(this.querySelectorAll('[data-slide]'));
        this.toggle = this.querySelector('.minos-hero__toggle');
        this.track = this.querySelector('.minos-hero__slides');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.hovered = false;
        this.focused = false;
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify && Shopify.designMode);
        this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.selectors.forEach(button => button.addEventListener('click', () => {
          this.show(Number(button.dataset.slide));
          this.schedule();
        }, { signal }));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          if (!this.paused && document.activeElement === this.toggle) this.focused = false;
          this.syncToggle();
          this.schedule();
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        }, { signal });
        this.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); }
        }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', event => {
          if (event.matches) this.paused = true;
          this.syncToggle();
          this.schedule();
        }, { signal });
        this.classList.add('is-ready');
        this.show(0);
        this.syncToggle();
        this.schedule();
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
      }
      syncToggle() {
        this.classList.toggle('is-paused', this.paused);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
      schedule() {
        window.clearTimeout(this.timer);
        const stopped = this.paused || this.hovered || this.focused || document.hidden;
        this.track.setAttribute('aria-live', stopped ? 'polite' : 'off');
        if (stopped) return;
        this.timer = window.setTimeout(() => {
          this.show((this.index + 1) % this.slides.length);
          this.schedule();
        }, this.interval);
      }
      show(index) {
        this.index = index;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          slide.classList.toggle('is-active', active);
          this.selectors[position].setAttribute('aria-current', String(active));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
